module.exports = __webpack_public_path__ + "static/media/Band_Form_4.f414ec54.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/24-25/Band_Form_4.pdf
// module id = 223
// module chunks = 0